import React from 'react';
import AltIso from 'alt/utils/AltIso';
import SeoActions from '../actions/SeoActions';
import _ from 'lodash';
import moment from 'moment';

import LoadingView from '../components/LoadingView';
import ShiftHeader from '../components/ShiftHeader';
import ShiftDetails from '../components/ShiftDetails';
import ShiftCandidates from '../components/ShiftCandidates';
import ShiftReport from '../components/ShiftReport';
import PostUpdateModal from '../components/PostUpdateModal';
import SendHiresListModal from '../components/SendHiresListModal';
import withRouter from '../utils/with-router';
import doRedirect from '../utils/doRedirect';

import connectToStores from 'alt/utils/connectToStores';

import CandidateActions from '../actions/CandidateActions';
import ShiftActions from '../actions/ShiftActions';
import ReportActions from '../actions/ReportActions';
import HiringActions from '../actions/HiringActions';

import ShiftStore from '../stores/ShiftStore';
import CandidateStore from '../stores/CandidateStore';
import ReportStore from '../stores/ReportStore';
import ChatStore from '../stores/ChatStore';
import HiringStore from '../stores/HiringStore';

@AltIso.define((props) => {
    return Promise.all([
        new Promise((resolve) => {
            SeoActions.pushTitle('Shift');
            resolve();
        }),
        ShiftStore.getShift(props.params.shiftId),
        CandidateStore.getCandidates(props.params.shiftId),
        ChatStore.getMessages({'shift': props.params.shiftId}),
        ReportStore.getReports(props.params.shiftId)
    ]);
})

@connectToStores
@withRouter
class Shift extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            showPostUpdateModal: false,
            showHiresFeedbackModal: false,
            shift: undefined,
            hiresListSuccess: null,
            isLoading: false
        };

    }

    componentDidMount() {
        const shift = this.props.sStore.detailShift;
        const activeTab = this.props.query.tab;

        if (Object.keys(shift).length && ((moment(shift.end_time) < moment() && shift.status != 'finished') || shift.status == 'ended')) {
            doRedirect(this.context.router, 'finish_shift', {shiftId: this.props.params.shiftId});
        }

        if (!!activeTab && _.inRange(parseInt(activeTab), 1, 3)) {
            this.setState({activeTab: parseInt(activeTab)});
        }
    }

    componentWillReceiveProps(nextProps) {
        const shift = this.props.sStore.detailShift;

        if (this.props.sStore.detailShiftError || (nextProps.hasLoaded && shift.company_id != this.props.user.profile.profile.company)) {
            doRedirect(this.context.router, 'agenda');
        }

        if (Object.keys(shift).length && ((moment(shift.end_time) < moment() && shift.status != 'finished') || shift.status == 'ended')) {
            doRedirect(this.context.router, 'finish_shift', {shiftId: this.props.params.shiftId});
        }

        if (nextProps.hiringStore.reloadPage && !this.props.hiringStore.reloadPage) {
            doRedirect(this.context.router, 'agenda');
        }

        if (nextProps.chStore.sendMessageError && Object.keys(nextProps.chStore.sendMessageError).length && this.props.chStore.sendMessageError === null) {
            doRedirect(this.context.router, 'agenda');
        }

        this.setState({hiresListSuccess: nextProps.sStore.hiresListSuccess});
    }

    componentWillUnmount() {
        ShiftActions.clearDetailShift();
        CandidateActions.clearCandidates();
        ReportActions.clearReports();
        HiringActions.clearReloadPage();
    }

    static getPropsFromStores() {
        return {
            sStore: ShiftStore.getState(),
            cStore: CandidateStore.getState(),
            chStore: ChatStore.getState(),
            rStore: ReportStore.getState(),
            hiringStore: HiringStore.getState()
        };
    }

    static getStores() {
        return [ShiftStore, CandidateStore, ChatStore, ReportStore, HiringStore];
    }

    tabClick(i) {
        this.setState({
            activeTab: i
        });
    }

    changeCandidateCount() {
        this.tabClick(1);
    }

    getRelevantCandidates(candidates) {
        return _.pluck(_.filter(candidates, candidate => {
            return candidate.hiring.status == 'hired';
        }), 'user.email');
    }

    duplicateShift(shift) {
        shift.id = 0;
        shift.status = 'draft';
        shift.candidates_declined = 0;
        shift.candidates_hired = 0;
        shift.candidates_pending = 0;
        shift.contacts.forEach(contact => {
            delete contact.id;
        });
        ShiftActions.duplicateShift(shift);
        this.context.router.transitionTo('editshift', { shiftId: 0});
    }

    sendHiresList(shift) {
        ShiftStore.sendHiresList(shift);
    }

    getNewPropsCallback() {
        ShiftStore.getShift(this.props.params.shiftId)
    }

    render() {
        const shift = this.props.sStore.detailShift;
        const candidatesLoaded = this.props.cStore.candidatesLoaded;

        if (!Object.keys(shift).length || !candidatesLoaded || this.state.isLoading) {
            return <LoadingView />;
        }

        const candidates = this.props.cStore.candidates;
        const reports = this.props.rStore.reports;
        const reportsReceived = this.props.rStore.reportsReceived;
        const messages = this.props.chStore.messages || {};
        const rateSaved = this.props.sStore.rateSaved;
        const reportCandidates = candidates.filter(candidate => {return ['hired', 'cancelled', 'cancelled by us'].indexOf(candidate.hiring.status) > -1});
        const hasReport = reportCandidates.length != 0 || shift.status == 'finished';
        const hireUpdate = shift.status == 'finished' || shift.status == 'cancelled' || shift.candidates_hired == 0;

        return (
            <div className="view-shift">
                <ShiftHeader duplicateShift={this.duplicateShift.bind(this, shift)} shiftId={this.props.params.shiftId} shift={shift} hireUpdate={hireUpdate} togglePostUpdateModal={this.togglePostUpdateModal.bind(this)} />

                <div className="view-content maxwidth-wrapper">

                    <div className="tabs">
                        <button onClick={this.tabClick.bind(this, 1)} className={"tab" + (this.state.activeTab === 1 ? " active" : "")}><span>Details</span></button>
                        <button
                            onClick={this.tabClick.bind(this, 2)}
                            className={"tab tab-candidates" + (this.state.activeTab === 2 ? " active" : "") + (shift.candidates_hired + shift.candidates_pending == 0 ? " disabled" : "")}
                            disabled={shift.candidates_hired + shift.candidates_pending == 0 ? true : false}>
                            <span>
                                Candidates
                                <span className="candidate-count">
                                    {shift.candidates_hired}
                                    {shift.workers_needed ? ' of ' : ''}{shift.workers_needed}
                                </span>
                            </span>
                        </button>
                        <button onClick={this.tabClick.bind(this, 3)} className={"tab" + (this.state.activeTab === 3 ? " active" : "") + (!hasReport ? " disabled" : "")} disabled={!hasReport ? true : false}><span>Report</span></button>

                        {hireUpdate ? '' : <button className="send-hires right" onClick={this.toggleHiresListModal.bind(this, shift)}>-> Send hires list</button>}
                    </div>

                    <div className="whitebox tab-content">
                        <ShiftDetails
                            getNewPropsCallback={this.getNewPropsCallback.bind(this)}
                            rateSaved={rateSaved}
                            shift={shift}
                            isActive={(this.state.activeTab === 1)} />

                        <ShiftCandidates
                            user={this.props.user.profile}
                            messages={messages}
                            changeCandidateCount={this.changeCandidateCount.bind(this)}
                            shift={shift}
                            candidates={candidates}
                            hiringStore={this.props.hiringStore}
                            isActive={(this.state.activeTab === 2)} />

                        <ShiftReport
                            sendHiresList={this.toggleHiresListModal.bind(this)}
                            candidates={reportCandidates}
                            shift={shift}
                            reports={reports}
                            reportsReceived={reportsReceived}
                            isActive={(this.state.activeTab === 3)} />
                    </div>

                </div>
                <PostUpdateModal shift={shift} candidates={this.getRelevantCandidates(candidates)} toggleModal={this.togglePostUpdateModal.bind(this)} isVisible={this.state.showPostUpdateModal} />
                <SendHiresListModal isActive={this.state.showHiresFeedbackModal} data={this.state.hiresListSuccess} toggleModal={this.toggleHiresListModal.bind(this, shift)} />
            </div>
        )
    }

    togglePostUpdateModal() {
        this.setState({
            showPostUpdateModal: !this.state.showPostUpdateModal
        });
    }

    toggleHiresListModal(shift) {
        if (this.state.showHiresFeedbackModal) {
            ShiftActions.clearHires();
        } else {
            this.sendHiresList(shift);
        }

        this.setState({
            showHiresFeedbackModal: !this.state.showHiresFeedbackModal
        });
    }
}


export default Shift;



/** WEBPACK FOOTER **
 ** ./app/src/views/Shift.js
 **/